<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        methods: {
            init() {
				// console.log(this.$route)
			},
        },
        mounted() {
            this.init();
		},
    }
</script>

<style lang="less">

	.flex {
		display: flex;
	}
	.flex-1 {
		flex: 1;
	}
	.flex-center {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.margin-bottom-10 {
		margin-bottom: 10px;
	}
	.margin-right-10 {
		margin-right: 10px !important;
	}
	.margin-top-10 {
		margin-top: 10px;
	}
	.text-center {
		text-align: center;
	}
	.display-none {
		display: none;
	}
	.full-width {
		width: 100% !important;
	} // element-ui
	.el-message.zd-el-message {
		padding: 8px 16px;
		border-radius: 4px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
		background-color: #ffffff;
		border-color: #ffffff;
		min-width: 0;
	}
	.el-message__content {
		font-size: 14px;
		color: #515a6e !important;
	}
	.info-check-content-div {
		.el-form-item__label {
			font-size: 14px;
			color: #8f9bb3 !important
		}
	}
	.el-menu {
		background-color: transparent !important;
		border-right: none !important;
	}
	.el-submenu__icon-arrow {
		color: #ffffff !important;
	}
	.el-menu-item:hover {
		background-color: transparent !important;
	}
	.el-submenu__title:hover {
		background-color: transparent !important;
	}
	.el-submenu.is-opened {
		background: linear-gradient(241deg, rgba(125, 95, 244, 0.17) 0%, rgba(105, 78, 237, 0.17) 100%)!important;
	}
	.el-menu-item.is-active {
		background-color: transparent !important;
		font-weight: 600;
		.second-menu-title {
			border-right: 5px solid #ffffff!important;
		}
	}
	.el-menu--popup {
		padding: 0!important;
		border-radius: 6px !important;
		overflow: hidden;
	}
	.el-menu--popup-right-start {
		.el-menu-item {
			background-color: #ffffff !important;
		}
		.second-menu-title {
			color: #BB87F3;
			font-size: 14px;
		}
	}
	/** 基本按钮 背景*/
	// .common-bg-button {
	// 	padding: 0 24px;
	// 	height: 32px;
	// 	background: rgba(187, 135, 243, 1);
	// 	border: 2px solid rgba(187, 135, 243, 1);
	// 	border-radius: 2px;
	// 	outline: 0;
	// 	line-height: 28px;
	// 	font-size: 12px;
	// 	font-weight: 400;
	// 	color: rgba(255, 255, 255, 1);
	// 	margin-right: 10px;
	// 	cursor: pointer;
	// }
	.common-bg-button {
		padding: 0 24px;
		height: 30px;
		background: #BB87F3;;
		border: 2px solid rgba(187, 135, 243, 1);
		border-radius: 2px;
		outline: 0;
		line-height: 16px;
		font-size: 12px;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		margin-right: 10px;
		cursor: pointer;
	}
	/** 基本按钮 - 空心背景*/
	// .common-empty-button {
	// 	padding: 0 24px;
	// 	height: 32px;
	// 	background: rgba(255, 255, 255, 1);
	// 	border: 2px solid rgba(187, 135, 243, 1);
	// 	border-radius: 2px;
	// 	outline: 0;
	// 	line-height: 28px;
	// 	font-size: 12px;
	// 	font-weight: 400;
	// 	color: #B780F3;
	// 	margin-right: 10px;
	// 	cursor: pointer;
	// }
	.common-empty-button {
		padding: 0 24px;
		height: 30px;
		background: rgba(255, 255, 255, 1);
		border: 2px solid rgba(187, 135, 243, 1);
		border-radius: 2px;
		outline: 0;
		line-height: 16px;
		font-size: 12px;
		font-weight: 400;
		color: #B780F3;
		margin-right: 10px;
		cursor: pointer;
	}
	/** 详情页*/
	.detail-container {
		.detail-bread-crumb-div {
			height: 64px;
			display: flex;
			align-items: center;
		}
		.detail-content-div {
			margin: 0 24px 24px 0;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px -8px 16px 0px rgba(42, 42, 68, 0.1);
			border-radius: 30px;
			min-height: 800px;
			padding: 24px 32px;
			display: flex;
			flex-direction: column;
			.page-title-div {
				font-size: 20px;
				font-weight: 500;
				color: rgba(0, 0, 0, 1);
			}
		}
		.detail-content-header-div {
			height: 72px;
			background: rgba(247, 247, 255, 1);
			margin: -24px -32px 0 -32px;
			border-top-left-radius: 30px;
			border-top-right-radius: 30px;
			align-items: center;
			padding: 0 32px;
			.left-page-title-div {
				font-size: 22px;
				font-weight: 500;
				color: rgba(187, 135, 243, 1);
				line-height: 72px;
			}
		}
		.detail-content-body-div {
			padding: 32px 0;
		}
		.detail-content-footer-div {
			height: 72px;
			background: rgba(247, 247, 255, 1);
			margin: 0px -32px -24px -32px;
			border-bottom-left-radius: 30px;
			display: flex;
			border-bottom-right-radius: 30px;
			align-items: center;
			padding: 0 32px;
		}
	}
	/** 列表页*/
	.list-container {
		.list-bread-crumb-div {
			height: 64px;
			display: flex;
			align-items: center;
		}
		.list-content-div {
			margin: 0 24px 24px 0;
			background: rgba(255, 255, 255, 1);
			box-shadow: 0px -8px 16px 0px rgba(42, 42, 68, 0.1);
			border-radius: 30px;
			min-height: 800px;
			padding: 24px 32px;
			.list-header-title-div {
				height: 72px;
				background: rgba(247, 247, 255, 1);
				margin: -24px -32px 0 -32px;
				border-top-left-radius: 30px;
				border-top-right-radius: 30px;
				align-items: center;
				padding: 0 32px;
				font-size: 22px;
				font-weight: 500;
				color: rgba(187, 135, 243, 1);
				line-height: 72px;
			}
			.page-querys {
				margin-top: 24px;
			}
			.page-action-btns {
				margin-bottom: 12px;
			}
		}
	}
	// pile-station detail distpicker 覆盖样式
	.distpicker-address-wrapper select {
        padding: .3rem .75rem !important;
        height:32px !important;
        font-size:13px !important;
	}
	.table-content {
        border-radius: 8px;
        border: 2px solid #EAEAEA;
        .page-action-btns {
            height: 65px;
            background: #FAFAFA;
            align-items: center;
            border-bottom: 2px solid #EAEAEA;
            .left-title {
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #9B9B9B;
                line-height: 25px;
                padding-left: 30px;
            }
            .right-btn {
                text-align: right;
            }
        }
        .list-table {
            margin: 30px 43px 30px 43px;
        }
        .list-pagination {
            margin-bottom: 30px;
        }
    }
</style>
